const firebaseConfig = {
    apiKey: "AIzaSyBKwZsA9d9H0FVAM8hEULUys43DBhi23ek",
    authDomain: "yoga-services-289e0.firebaseapp.com",
    projectId: "yoga-services-289e0",
    storageBucket: "yoga-services-289e0.appspot.com",
    messagingSenderId: "704062956755",
    appId: "1:704062956755:web:a34a50792465a907e4e026"
  };

  export default firebaseConfig;